module.exports = __webpack_public_path__ + "static/media/nft-13.1f8d1b6e.jpg";